import { useNavigate } from "react-router-dom";
import { SortResponse } from "../GPTConvoTypes";
import { BrieMessageBody, BrieMessageHeader } from "./SearchMessage";
import { sortCommand } from "../../../api/api-hooks/conversations/useUpdateGPTConversations.ts/sortCommand";

interface Props {
  message: SortResponse;
}

export default function SortMessage({ message }: Props) {
  const navigate = useNavigate();

  return (
    <>
      <BrieMessageHeader title="Sort Command" />
      <BrieMessageBody message={message.Message} onClick={performSort} />
    </>
  );

  function performSort() {
    sortCommand({ message, setQuery: undefined, navigate });
  }
}
